<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Leaves Requests</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="[getDashboardRoute()]"><i class="ti ti-smart-home"></i></a>
          </li>
          <!-- <li class="breadcrumb-item">
              Employee
            </li> -->
          <li class="breadcrumb-item active" aria-current="page">Leaves Requests</li>
          <li></li>
        </ol>
      </nav>
    </div>
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      <div class="me-2 mb-2 d-none">
        <div class="dropdown">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            <i class="ti ti-file-export me-1"></i>Export
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
              >
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1"
                ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="mb-2">
        <ng-container *appHasPermission="{ leaveRequests: ['add'] }">
          <a
            href="javascript:void(0)"
            class="btn btn-primary d-flex align-items-center"
            (click)="openBusinessModal(addBusinessModals)"
            ><i class="ti ti-circle-plus me-2"></i>Apply Leave</a
          >
        </ng-container>
      </div>
      <div class="head-icons ms-2 d-none">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <!-- Leaves Info -->
  <div class="row">
    <div class="col-xl-3 col-md-6">
      <div class="card bg-green-img">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0 me-2">
                <span
                  class="avatar avatar-md rounded-circle bg-white d-flex align-items-center justify-content-center"
                >
                  <i class="ti ti-user-check text-success fs-18"></i>
                </span>
              </div>
            </div>
            <div class="text-end">
              <p class="mb-1">Total Present (Today) <span class="text-danger">*</span></p>
              <h4>1</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="card bg-pink-img">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0 me-2">
                <span
                  class="avatar avatar-md rounded-circle bg-white d-flex align-items-center justify-content-center"
                >
                  <i class="ti ti-user-edit text-pink fs-18"></i>
                </span>
              </div>
            </div>
            <div class="text-end">
              <p class="mb-1">Planned Leaves <span class="text-danger">*</span></p>
              <h4>1</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="card bg-yellow-img">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0 me-2">
                <span
                  class="avatar avatar-md rounded-circle bg-white d-flex align-items-center justify-content-center"
                >
                  <i class="ti ti-user-exclamation text-warning fs-18"></i>
                </span>
              </div>
            </div>
            <div class="text-end">
              <p class="mb-1">Unplanned Leaves <span class="text-danger">*</span></p>
              <h4>1</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="card bg-blue-img">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0 me-2">
                <span
                  class="avatar avatar-md rounded-circle bg-white d-flex align-items-center justify-content-center"
                >
                  <i class="ti ti-user-question text-info fs-18"></i>
                </span>
              </div>
            </div>
            <div class="text-end">
              <p class="mb-1">Pending Requests <span class="text-danger">*</span></p>
              <h4>1</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Leaves Info -->

  <!-- Leaves list -->
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-4">
      <h5>Leaves Requests List</h5>
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-4">
        <div class="me-3">
          <select
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
          </select>
        </div>

        <!-- <div *ngIf="showDatePicker" class="me-3"> -->
        <div class="me-3">
          <div class="input-icon position-relative">
            <span class="input-icon-addon">
              <i class="ti ti-calendar text-gray-9"></i>
            </span>
            <!-- <input
              type="text"
              id="dateRangeInput"
              class="form-control date-range bookingrange"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
              [(ngModel)]="dateRange"
              (ngModelChange)="loadAppliedLeaves()"
              ngxDaterangepickerBootstrap
              [locale]="{ applyLabel: 'ok', format: 'DD-MM-YYYY' }"
              startKey="start"
              endKey="end"
              style="width: 210px"
            /> -->
            <input
              type="text"
              id="dateRangeInput"
              class="form-control date-range bookingrange"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
              [(ngModel)]="dateRange"
              (ngModelChange)="loadAppliedLeaves()"
              ngxDaterangepickerBootstrap
              [locale]="{ applyLabel: 'ok', format: 'DD/MM/YYYY' }"
              startKey="startDate"
              endKey="endDate"
              [opens]="'right'"
              [drops]="'down'"
              style="width: 210px"
            />
          </div>
        </div>
        <!-- <div class="me-3">
          <select class="form-select" [(ngModel)]="leaveType" (change)="loadAppliedLeaves()">
            <option value="" selected>Select Type</option>
            <option *ngFor="let leave of leaveTypes" [value]="leave">
              {{ leave }}
            </option>
          </select>
        </div> -->
        <div class="me-3">
          <select class="form-select" [(ngModel)]="status" (change)="onStatusChange()">
            <option value="" selected>Select Status</option>
            <option [value]="statusEnum.APPROVED">{{ statusEnum.APPROVED }}</option>
            <option [value]="statusEnum.PENDING">{{ statusEnum.PENDING }}</option>
            <option [value]="statusEnum.REJECTED">{{ statusEnum.REJECTED }}</option>
            <option [value]="statusEnum.CANCELLED">{{ statusEnum.CANCELLED }}</option>
          </select>
        </div>
        <div class="dropdown d-none">
          <a
            href="javascript:void(0);"
            class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
            data-bs-toggle="dropdown"
          >
            Sort By : Last 7 Days
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Recently Added</a>
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Ascending</a>
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Desending</a>
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Last Month</a>
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1">Last 7 Days</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <ng-container *ngIf="appliedLeaves$ | async as leaves; else noRecords">
          <table class="table datatable" *ngIf="leaves.length > 0">
            <thead class="thead-light">
              <tr>
                <!-- <th class="no-sort">
                  <div class="form-check form-check-md">
                    <input class="form-check-input" type="checkbox" id="select-all">
                  </div>
                </th> -->
                <th>Employee</th>
                <th>Leave Type</th>
                <th>From</th>
                <th>To</th>
                <th>Approvers</th>
                <th>Approved By</th>
                <th>Submitted On</th>
                <th>No. of Days</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let leave of appliedLeaves$ | async">
                <!-- <td>
                  <div class="form-check form-check-md">
                    <input class="form-check-input" type="checkbox">
                  </div>
                </td> -->
                <td [ngClass]="{ clickable: leave.dateRangeForHalfDay?.length }">
                  <div class="d-flex align-items-center file-name-icon">
                    <a
                      [routerLink]="['/hrm/employee', leave.userId]"
                      class="avatar avatar-md border avatar-rounded"
                    >
                      <!-- <img [src]="apiEndpoint + leave.employee.user.picture" class="img-fluid" alt="img"> -->
                      <!-- <img [src]="defaultImg" class="img-fluid rounded-circle" alt="Img" /> -->
                      <ng-container *ngIf="leave.user?.picture; else initials">
                        <img
                          [src]="
                            leave.user?.picture
                              ? apiEndpoint + '/uploads/' + leave.user?.picture
                              : defaultImg
                          "
                          class="img-fluid rounded-circle"
                          alt="img"
                          style="width: 100%; height: 100%; object-fit: cover"
                        />
                      </ng-container>

                      <ng-template #initials>
                        <span
                          class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                          style="width: 100%; height: 100%"
                          >{{ getInitials(leave.user?.firstName, leave.user?.lastName) }}</span
                        >
                      </ng-template>
                    </a>
                    <div class="ms-2">
                      <h6 class="fw-medium">
                        <a [routerLink]="['/hrm/employee', leave.userId]"
                          >{{ leave.user?.firstName }} {{ leave.user?.lastName }}</a
                        >
                      </h6>
                      <span class="fs-12 fw-normal">{{
                        leave.user?.designation?.designationName
                      }}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <p class="fs-14 fw-medium d-flex align-items-center mb-0">
                      {{ leave.leaveType }}
                    </p>
                    <a
                      href="javascript:void(0)"
                      class="ms-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="right"
                      data-bs-title="I am currently experiencing a fever and design & Development"
                      [attr.aria-label]="leave.reason"
                      [attr.data-bs-title]="leave.reason"
                      ngbTooltip="{{ leave.reason }}"
                      placement="right"
                      *ngIf="leave.reason"
                    >
                      <i class="ti ti-info-circle text-info"></i>
                    </a>
                  </div>
                </td>
                <td>
                  {{ leave.fromDate | date }}
                </td>
                <td>
                  {{ leave.toDate | date }}
                </td>
                <td>
                  <div class="d-flex align-items-center file-name-icon">
                    <div class="ms-2">
                      <!-- <h6 class="fw-medium" *ngIf="leave.leavemanager?.firstName ">
                        <a href="javascript:void(0);">{{ leave.leavemanager?.firstName }}</a>
                      </h6> -->

                      <!-- Display full name  -->
                      <h6 class="fw-medium" *ngIf="leave.leavemanager">
                        <a href="javascript:void(0);"
                          >{{ leave.leavemanager?.firstName }} {{ leave.leavemanager?.lastName }}</a
                        >
                      </h6>

                      <hr
                        *ngIf="
                          leave.managerId !== leave.requestManagerId &&
                          leave.leaverequestManager?.firstName
                        "
                      />

                      <h6
                        class="fw-medium"
                        *ngIf="
                          leave.managerId !== leave.requestManagerId &&
                          leave.leaverequestManager?.firstName
                        "
                      >
                        <a href="javascript:void(0);"
                          >{{ leave.leaverequestManager?.firstName }}
                          {{ leave.leaverequestManager?.lastName }}</a
                        >
                      </h6>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    class="d-flex align-items-center file-name-icon"
                    *ngIf="leave.status !== 'Pending' && leave.approver"
                  >
                    <!-- <a href="javascript:void(0);" class="avatar avatar-md border avatar-rounded">
                    <img
                      [src]="
                        leave.approver.picture ? apiEndpoint + leave.approver.picture : defaultImg
                      "
                      class="img-fluid rounded-circle"
                      alt="img"
                    />
                  </a>
                  <div class="ms-2">
                    <h6 class="fw-medium">
                      <a href="javascript:void(0);">{{ leave.approver.firstName }}</a>
                    </h6>
                  </div> -->
                    <ng-container *ngIf="leave.approver.picture; else initials">
                      <img
                        [src]="apiEndpoint + '/uploads/' + leave.approver.picture"
                        class="img-fluid rounded-circle"
                        alt="img"
                        style="width: 40px; height: 40px; object-fit: cover"
                      />
                    </ng-container>

                    <ng-template #initials>
                      <span
                        class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                        style="width: 30px; height: 30px"
                        >{{ getInitials(leave.approver.firstName, leave.approver.lastName) }}</span
                      >
                    </ng-template>
                    <div class="ms-2">
                      <h6 class="fw-medium">
                        <a href="javascript:void(0);"
                          >{{ leave.approver.firstName }} {{ leave.approver.lastName }}</a
                        >
                      </h6>
                    </div>
                  </div>
                </td>
                <td>
                  {{ leave.createdAt | date: 'medium' }}
                </td>
                <td>{{ leave.leaveDays }}</td>
                <!-- <td>{{ calculateLeaveDays(leave.startDate, leave.endDate) }}</td> -->

                <td>
                  <span
                    *ngIf="leave.status === 'Approved'"
                    class="badge badge-success d-inline-flex align-items-center badge-xs"
                  >
                    <i class="ti ti-point-filled me-1"></i>{{ leave.status }}</span
                  >
                  <span
                    *ngIf="leave.status === 'Cancelled' || leave.status === 'Rejected'"
                    class="badge badge-danger d-inline-flex align-items-center badge-xs"
                  >
                    <i class="ti ti-point-filled me-1"></i>{{ leave.status }}</span
                  >
                  <span
                    *ngIf="leave.status === 'Pending'"
                    class="badge badge-warning d-inline-flex align-items-center badge-xs"
                  >
                    <i class="ti ti-point-filled me-1"></i>{{ leave.status }}</span
                  >
                </td>
                <td>
                  <div class="action-icon d-inline-flex">
                    <!-- <a href="#" class="me-2" data-bs-toggle="modal" data-bs-target="#edit_leaves"
                      (click)="openEditLeave(editBusinessModal, leave);"><i class="ti ti-edit"></i></a> -->
                    <!-- <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#delete_modal"><i class="ti ti-trash"></i></a> -->
                    <ng-container *appHasPermission="{ leaveRequests: ['edit'] }">
                      <a
                        href="javascript:void(0)"
                        data-bs-toggle="modal"
                        data-bs-target="#view_details"
                        (click)="openOffcanvasLeave(leave)"
                        title="View Leave Detail"
                      >
                        <i class="ti ti-eye"></i>
                      </a>
                      <ng-container *ngIf="leave.status === 'Pending'">
                        <a
                          *appHasPermission="{ leaveRequests: ['edit'] }"
                          href="javascript:void(0)"
                          (click)="openBlockUnblock(cancelAppliedLeaveModal, leave, 'Approve')"
                          title="Approve"
                        >
                          <i class="ti ti-check text-success"></i>
                        </a>
                        <a
                          *appHasPermission="{ leaveRequests: ['edit'] }"
                          href="javascript:void(0)"
                          (click)="openBlockUnblock(cancelAppliedLeaveModal, leave, 'Reject')"
                          title="Reject"
                        >
                          <i class="ti ti-ban text-danger"></i>
                        </a>

                        <a
                          *appHasPermission="{ leaveRequests: ['edit'] }"
                          href="javascript:void(0)"
                          (click)="openBlockUnblock(cancelAppliedLeaveModal, leave, 'Cancel')"
                          title="Cancel"
                        >
                          <i class="ti ti-x text-warning"></i>
                        </a>
                        <!-- <button
                        type="button"
                        class="btn btn-success me-2"
                        (click)="openBlockUnblock(cancelAppliedLeaveModal, leave, 'Approve')"
                      >
                        Approve
                      </button>

                      <button
                        type="button"
                        class="btn btn-danger me-2"
                        (click)="openBlockUnblock(cancelAppliedLeaveModal, leave, 'Reject')"
                      >
                        Reject
                      </button>

                      <button
                        type="button"
                        class="btn btn-warning"
                        (click)="openBlockUnblock(cancelAppliedLeaveModal, leave, 'Cancel')"
                      >
                        Cancel
                      </button> -->
                      </ng-container>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-template #noRecords>
          <div class="text-center">Record not available</div>
        </ng-template>
      </div>
    </div>
    <!-- <div class="has-text-centered mt-3" *ngIf="appliedLeaveList.length > 0">
        <app-pagination [currentPage]="currentPage" [pageSize]="pageLimit" [totalRows]="totalCount"
          (pageChange)="onPageChange($event)"></app-pagination>
      </div> -->
    <ng-container *ngIf="appliedLeaves$ | async as leaves">
      <div class="d-flex align-items-center justify-content-between ms-2" *ngIf="leaves.length > 0">
        <div>
          Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
          {{ totalCount }} entries
        </div>
        <div class="has-text-centered mt-3">
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageLimit"
            [totalRows]="totalCount"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- /Leaves list -->
</div>

<ng-template #cancelAppliedLeaveModal let-modal>
  <!-- <div class="modal fade" id="delete_modal">
      <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content"> -->
  <div class="modal-body text-center">
    <span
      class="avatar avatar-xl mb-3"
      [ngClass]="
        blockUnblockStatus !== 'Approve'
          ? 'bg-transparent-danger text-danger'
          : 'bg-transparent-success text-success'
      "
    >
      <i
        [ngClass]="
          blockUnblockStatus !== 'Approve' ? 'ti ti-lock fs-36' : 'ti ti-lock-open-2 fs-36'
        "
      ></i>
    </span>
    <h4 class="mb-1">Confirm {{ blockUnblockStatus }}</h4>
    <p class="mb-3">You want to {{ blockUnblockStatus }} the leave.</p>
    <form [formGroup]="form">
      <div class="col-md-12" *ngIf="blockUnblockStatus !== 'Approve'">
        <div class="mb-3">
          <label class="form-label">Reason</label>
          <textarea
            class="form-control"
            rows="3"
            formControlName="statusReason"
            appTrimInput
          ></textarea>
          <div *ngIf="form.get('statusReason')?.invalid && form.get('statusReason')?.touched">
            <span class="text-danger">
              {{ getErrorMessage('statusReason') }}
            </span>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <a
          href="javascript:void(0);"
          class="btn btn-light me-3"
          data-bs-dismiss="modal"
          (click)="onClose()"
          >Cancel</a
        >
        <a href="javascript:void(0);" class="btn btn-danger" (click)="onSubmit()"
          >Yes, {{ blockUnblockStatus }}</a
        >
      </div>
    </form>
  </div>
  <!-- </div>
      </div>
    </div> -->
</ng-template>

<!-- Add Leaves -->
<ng-template #addBusinessModals let-modal class="custom-modal-width">
  <!-- <div class="modal fade" id="add_leaves">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Apply Leave</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="form">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Business Entity <span class="text-danger">*</span></label
              >
              <!-- <select
                class="form-select"
                formControlName="businessId"
                [(ngModel)]="selectedBusinessId"
                (change)="onBusinessChange(selectedBusinessId)"
              >
                <option value="" selected disabled>Select Business Entity</option>
                <option *ngFor="let business of businesses$ | async" [value]="business.id">
                  {{ business.businessName | capitalize }}
                </option>
              </select> -->
              <ng-select
                class="me-3 w-100"
                [items]="businesses$ | async"
                bindValue="id"
                placeholder="Select Business Entity"
                [searchable]="true"
                [clearable]="true"
                [searchFn]="customSearchFnBusiness"
                style="width: 200px"
                formControlName="businessId"
                [(ngModel)]="selectedBusinessId"
                (change)="onBusinessChange(selectedBusinessId)"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
              </ng-select>
              <div *ngIf="form.get('businessId')?.invalid && form.get('businessId')?.touched">
                <span class="text-danger">{{ getErrorMessage('businessId') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label class="col-form-label" for="userId"
                >Employees <span class="text-danger">*</span></label
              >
              <ng-select
                class="me-3 w-100"
                [items]="employees$ | async"
                bindValue="id"
                placeholder="Select Employee"
                [searchable]="true"
                [clearable]="true"
                [searchFn]="customSearchFnEmployee"
                style="width: 200px"
                formControlName="userId"
                (change)="onEmployeeSelect()"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
                </ng-template>
              </ng-select>
              <div *ngIf="form.get('userId')?.invalid && form.get('userId')?.touched">
                <span class="text-danger">{{ getErrorMessage('userId') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label">Leave Policy</label>
            <ng-select
              class="me-3 w-100"
              [items]="leavePolicies$ | async"
              bindValue="leavePolicy"
              placeholder="Select Leave Policy"
              [searchable]="true"
              [clearable]="true"
              style="width: 200px"
              formControlName="leavePolicy"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.leavePolicy?.title | capitalize }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <div class="d-flex justify-content-between w-100">
                  <span>{{ item.leavePolicy?.title | capitalize }}</span>
                  <span>{{ item.currentBalance }} Days</span>
                </div>
              </ng-template>
            </ng-select>
            <div *ngIf="form.get('leavePolicyId')?.invalid && form.get('leavePolicyId')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('leavePolicyId') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label">From - To </label>
            <input
              type="text"
              id="dateRangeInputModal"
              class="form-control date-range bookingrange"
              formControlName="daterange"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
              bsdaterangepicker
              style="width: 100%"
            />
            <!-- <input type="date" class="form-control datetimepicker" placeholder="dd/mm/yyyy" formControlName="fromDate"
                (change)="onFromDateChange(); generateDateRange();"  > -->
            <!-- <div class="input-icon position-relative">
                <input type="date" class="form-control datetimepicker" placeholder="dd/mm/yyyy"
                  formControlName="fromDate" (change)="onFromDateChange()" [Disabled]="disabledDates"> -->
            <!-- <ngb-datepicker  formControlName="fromDate"  [markDisabled]="isDisabled"> </ngb-datepicker> -->

            <!-- <span class="input-icon-addon">
                                              <i class="ti ti-calendar text-gray-7"></i>
                                          </span> -->
            <div *ngIf="form.get('fromDate')?.invalid && form.get('fromDate')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('fromDate') }}
              </span>
            </div>

            <!-- </div> -->
          </div>
        </div>

        <div class="col-md-12">
          <div class="mb-3">
            <!-- Show Half Day Selection for Each Date -->

            <div *ngFor="let day of dateRangeforHalfDay; let i = index">
              <div class="ms-3">
                <label class="form-label fw-bold me-2">{{ day.date | date: 'dd MMMM yyyy' }}</label>

                <!-- Full Day / Half Day Selection -->
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    [name]="'dayOption' + i"
                    (change)="setDayType(i, 'FullDay')"
                    [checked]="day.selectionType === 'FullDay'"
                  />
                  <label class="form-check-label">Full Day</label>
                </div>

                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    [name]="'dayOption' + i"
                    (change)="setDayType(i, 'HalfDay')"
                    [checked]="day.selectionType === 'HalfDay'"
                  />
                  <label class="form-check-label">Half Day</label>
                </div>

                <!-- Show Half Day Options Only if Half Day is Selected -->
                <div class="ms-5 mb-2" *ngIf="day.selectionType === 'HalfDay'">
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      [name]="'halfDayOption' + i"
                      (change)="onHalfDayChange(i, 'FirstHalf')"
                      [checked]="day.halfDayOption === 'FirstHalf'"
                    />
                    <label class="form-check-label">First Half</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      [name]="'halfDayOption' + i"
                      (change)="onHalfDayChange(i, 'SecondHalf')"
                      [checked]="day.halfDayOption === 'SecondHalf'"
                    />
                    <label class="form-check-label">Second Half</label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ensure that First Half and Second Half are not shown when Full Day is selected -->
            <div *ngIf="form.get('offType')?.value === offTypeEnum.FULLDAY">
              <!-- Logic for full day selection, if needed -->
            </div>

            <div *ngIf="form.get('offType')?.invalid && form.get('offType')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('offType') }}
              </span>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-6">
            <div class="mb-3">
              <select class="form-select" formControlName="offType">
                <option value="" selected>Select Type</option>
                <option [value]="offTypeEnum.FullDay">{{ offTypeEnum.FullDay }}</option>
                <option [value]="offTypeEnum.FirstHalf">{{ offTypeEnum.FirstHalf }}</option>
                <option [value]="offTypeEnum.SecondHalf">{{ offTypeEnum.SecondHalf }}</option>
              </select>
              <div *ngIf="form.get('offType')?.invalid && form.get('offType')?.touched">
                <span class="text-danger">
                  {{ getErrorMessage('offType') }}
                </span>
              </div>
            </div>
          </div> -->
        <div class="col-md-6 d-none">
          <div class="mb-3">
            <label class="form-label">No. of Days</label>
            <input type="text" class="form-control" disabled />
          </div>
        </div>
        <div class="col-md-6 d-none">
          <div class="mb-3">
            <label class="form-label">Remaining Days</label>
            <input type="text" class="form-control" value="8" disabled />
          </div>
        </div>

        <div class="col-md-12">
          <div class="mb-3">
            <label class="form-label">Reason</label>
            <textarea
              class="form-control"
              rows="3"
              formControlName="reason"
              appTrimInput
            ></textarea>
            <div *ngIf="form.get('reason')?.invalid && form.get('reason')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('reason') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" (click)="onSubmit()" [disabled]="!form.valid">
        Apply Leave
      </button>
    </div>
  </form>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- /Add Leaves -->

<!-- leave details -->
<div
  class="modal fade"
  id="view_details"
  tabindex="-1"
  aria-labelledby="viewDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="viewDetailsLabel">Request Details</h5>
        <button
          type="button"
          class="btn-close custom-btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <i class="ti ti-x"></i>
        </button>
      </div>
      <div class="modal-body" *ngIf="selectedLeave">
        <p>
          <strong>Employee:</strong> {{ selectedLeave.user?.firstName }}
          {{ selectedLeave.user?.lastName }}
        </p>
        <p>
          <strong>Applied By:</strong> {{ selectedLeave.appliedByUser?.firstName }}
          {{ selectedLeave.appliedByUser?.lastName }}
        </p>
        <p><strong>Leave Type:</strong> {{ selectedLeave.leaveType }}</p>
        <p>
          <strong>Date Range:</strong> {{ selectedLeave.fromDate | date: 'mediumDate' }} -
          {{ selectedLeave.toDate | date: 'mediumDate' }}
        </p>
        <p><strong>No. of Days:</strong> {{ selectedLeave.leaveDays }}</p>

        <p><strong>Status:</strong> {{ selectedLeave.status }}</p>
        <p>
          <strong>Approved By:</strong> {{ selectedLeave.approver?.firstName }}
          {{ selectedLeave.approver?.lastName }}
        </p>
        <p><strong>Reason:</strong> {{ selectedLeave.reason }}</p>

        <!-- <p><strong>Date:</strong> {{ selectedLeave.date | date: 'medium' }}</p>
        <p><strong>Clock In:</strong> {{ selectedLeave.clockIn | date: 'shortTime' }}</p>
        <p><strong>Clock Out:</strong> {{ selectedLeave.clockOut | date: 'shortTime' }}</p> -->

        <div *ngIf="selectedLeave.dateRangeforHalfDay">
          <hr />
          <h6 class="mt-2">Requested Dates:</h6>
          <ul class="list-group">
            <li
              *ngFor="let day of parsedDateRange; let i = index"
              class="list-group-item d-flex justify-content-between"
            >
              <span>
                <strong>Date:</strong> {{ day.date | date: 'dd MMMM yyyy' }}<br />
                <strong>For:</strong> {{ day.selectionType }}
                {{ day.halfDayOption ? ' - ' + day.halfDayOption : '' }}
              </span>
            </li>
          </ul>
        </div>
        <!-- Add more fields as needed -->
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div> -->
    </div>
  </div>
</div>

<!-- end leave details -->
